// @flow
import * as React from 'react'
import glamorous, { Div } from 'glamorous'
import Isoptope from 'isotope-layout'
import { padding, breakpoint } from 'style'

import type { GlamorousComponent } from 'glamorous'

const GridItem = glamorous
  .div(
    {
      ...padding(2),
      width: `${(1 / 3) * 100}%`,
      ...breakpoint.small({
        width: '100%',
      }),
    },
    ({ filterTag = '' }: { filterTag?: string }) => filterTag,
  )
  .withProps({ className: 'grid-item' })

type Props = {
  filter?: string,
  children: React.Node,
}

class Grid extends React.Component<Props> {
  static Item: GlamorousComponent<*, *> = GridItem

  componentDidMount() {
    if (!this.gridEl) return
    this.iso = new Isoptope(this.gridEl, {
      itemSelector: '.grid-item',
      percentPosition: true,
      isJqueryFiltering: false,
      masonry: {
        columnWidth: '.grid-sizer',
        horizontalOrder: true,
      },
      initLayout: false,
    })

    const { filter } = this.props

    if (filter != null) {
      this.filterItems(filter)
    }

    this.iso.arrange()
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.filter != null) {
      this.filterItems(nextProps.filter)
    }
  }

  filterItems = (filterTag: string) => {
    const filter = filterTag === '*' ? filterTag : `.${filterTag}`
    this.iso.arrange({ filter })
  }

  gridEl: ?HTMLElement

  iso: Isoptope

  render() {
    const { children } = this.props
    return (
      <Div
        innerRef={el => {
          this.gridEl = el
        }}
        css={{ ...padding.y(3) }}
      >
        <GridItem className="grid-sizer" />
        {children}
      </Div>
    )
  }
}

export default Grid



// WEBPACK FOOTER //
// ./src/components/Grid.js